/** Sample dashboard data shown until the client portal is connected to real accounts. */
export const SAMPLE_PROJECT = {
  name: "Sample project",
  currentStage: 2, // index into PROCESS_STAGES
};

export const SAMPLE_FILES = [
  { name: "Homepage design — v1.pdf", kind: "Design", date: "Sample" },
  { name: "Brand assets.zip", kind: "Assets", date: "Sample" },
  { name: "Page copy draft.docx", kind: "Copy", date: "Sample" },
];

export const SAMPLE_INVOICES = [
  { id: "INV-0001", item: "Website Development", amount: "$600.00", status: "Paid" as const },
  { id: "INV-0002", item: "Hosting & Maintenance", amount: "$75.00", status: "Due" as const },
];
